export default function clearAction(state, payload) {
    return {
    };
}